import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

// Self-hosted variable fonts (ui/DESIGN.md §4: Geist for headings and UI, as in the
// app; Geist Mono for data), then the Tailwind entry that pulls in ui/theme.css.
import "@fontsource-variable/geist";
import "@fontsource-variable/geist-mono";
import "@/styles.css";

import { AuthProvider } from "@/lib/auth";
import { ThemeProvider } from "@/lib/theme";
import { App } from "@/App";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error('Root element "#root" not found.');

createRoot(rootEl).render(
  <StrictMode>
    {/* ThemeProvider wraps everything: the theme belongs to the document, not to a
        route or a session, and /login + /callback render outside the app shell. */}
    <ThemeProvider>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  </StrictMode>,
);
